export default {
  async attachUserToDuplicateCluster(clusterArray) {
    clusterArray.forEach(item => {
      // Check for duplicates based on the cluster 'Name' property
      const duplicateItems = clusterArray.filter(obj => obj.Name === item.Name);

      // If there are duplicates and the current item's 'ownedByName' is not empty
      if (duplicateItems.length > 1 && item.ownedByName) {
        // Modify the 'Name' property by appending the 'ownedByName' value
        duplicateItems.forEach(duplicate => {
          duplicate.Name = `${duplicate.Name} (${duplicate.ownedByName})`;
        });
      }
    });
    return clusterArray; // Return the modified array of objects
  }
}
